import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerContainer: {
            flexDir: 'column',
            maxW: remCalc(1400),
            margin: 'auto',
            px: remCalc(24),
            pt: {base: remCalc(24), lg: remCalc(32)},
            pb: {base: remCalc(24), lg: remCalc(96)},
            gap: {base: remCalc(24), md: remCalc(32)},
        },
        headerLabel: {
            textStyle: 'head-large',
        },
        elementsGrid: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: remCalc(24),
        },
        featureBox: {
            display: 'flex',
            w: {base: '100%', lg: `calc(50% - ${remCalc(12)})`},
            gap: {base: remCalc(24), md: remCalc(32)},
        },
        elementImage: {
            w: remCalc(80),
            h: remCalc(80),
            objectFit: 'cover',
        },
        textContainer: {
            flexDirection: 'column',
            gap: remCalc(8),
        },
        title: {
            fontWeight: 500,
            textStyle: 'head-xsmall',
        },
        description: {
            textStyle: 'body-medium',
        },
    },
}
